/* IBM Confidential‌ - OCO Source Materials‌ - (C) COPYRIGHT IBM CORP. 2020 - The source code for this program is not published or otherwise‌ divested of its trade secrets, irrespective of what has been‌ deposited with the U.S. Copyright Office. */

import React from 'react';
import Information from "@carbon/icons-react/lib/information/20";
import { AppMsg } from '../utils';

//Function for Main Navigation(Header) About Button
export function about(tririgaContextUrl) {
    
    return({
    label:AppMsg.getMessage(AppMsg.APP_ABOUT),
    btnContent: <Information fill="white" description="Icon" className="about-icon"/>,
    element:'button',
    onClick:() => {_aboutBtnClicked(tririgaContextUrl)},
    })
}

//Function when about button is clicked
function _aboutBtnClicked(tririgaContextUrl){
    
    let browserType = window.navigator.userAgent.toLowerCase();
    let height = 350;
    if(browserType.includes("safari")&& !browserType.includes("chrome")){
      height =  390;
    }
    let path = `${tririgaContextUrl}/html/en/default/common/tririgaAbout.jsp`;
    window.open(path,"about_window","toolbar=0,scrollbars=0,menubar=0,resizable=0,height="+height+",width=460"); 
}